import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=d8c54e54&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=d8c54e54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c54e54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c54e54')) {
      api.createRecord('d8c54e54', component.options)
    } else {
      api.reload('d8c54e54', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=d8c54e54&scoped=true", function () {
      api.rerender('d8c54e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Contact.vue"
export default component.exports